import type { ProgressCardsData } from "@memorang/ui/components/ProgressApplet/types";
import { skillIconMap } from "@memorang/ui/constants";

export const MOCK_PROGRESS_CARDS: ProgressCardsData = {
	masteryTags: [],
	needsImprovement: [
		{
			title: "Reading",
			distribution: { high: 110, medium: 30, low: 10, none: 6 },
			score: 88,
			numItems: 156,
			rightText: "156 items",
			icon: skillIconMap.Reading,
		},
		{
			title: "Listening",
			distribution: { high: 120, medium: 28, low: 8, none: 4 },
			score: 91,
			numItems: 160,
			rightText: "160 items",
			icon: skillIconMap.Listening,
		},
	],
	summary: {
		title: "Summary",
		subtitle: "Your strengths and focus areas",
		tooltip:
			"A snapshot of where you're strongest and where extra practice will help most.",
		data: [
			{
				name: "Strengths",
				list: [
					{
						icon: "ear-hearing",
						title: "Photograph",
						description: "Listening · 96% progress",
						chipLabel: "96%",
					},
					{
						icon: "book-open-page-variant-outline",
						title: "Incomplete Sentences",
						description: "Reading · 92% progress",
						chipLabel: "92%",
					},
				],
			},
			{
				name: "Focus areas",
				list: [
					{
						icon: "book-open-page-variant-outline",
						title: "Multiple Passage",
						description: "Reading · 74% progress",
						chipLabel: "74%",
					},
					{
						icon: "ear-hearing",
						title: "Talks",
						description: "Listening · 78% progress",
						chipLabel: "78%",
					},
				],
			},
		],
	},
	practiceTests: {
		title: "Practice Tests",
		subtitle: "Based on 2 completed assessments",
		avgScore: 87,
		list: [
			{
				title: "Diagnostics: Listening",
				description: "Completed · 30 items",
				status: "COMPLETE",
				numericId: 1,
				cta: "Review",
				id: "diag-listening",
				score: 90,
			},
			{
				title: "Diagnostics: Reading",
				description: "Completed · 27 items",
				status: "COMPLETE",
				numericId: 2,
				cta: "Review",
				id: "diag-reading",
				score: 84,
			},
		],
	},
};
